//#region Routes
export const LOGIN = "";
export const NEWCLIENTREQUEST = "/newClientRequestForm";
export const NOTFOUND = "/*";
export const NOACCESS = "/unauthorized";
export const CPPCODEBULKAPPROVAL = "";
export const CPPOCODESEARCH = "/cppoCodeSearch";
export const CPPCODELIST = "/cppoCodeList";
export const ADMINBLADE = "/administration";
export const SUPERADMIN = "/superadmin";
export const NEWCPPREQUEST = "/newcpprequest";
export const NEWPROGRAMPROJECTREQUEST = "/newProgramProjectList";
export const NEWPROGRAMREQUEST = "/newProgramProjectRequestForm";
export const NEWPROJECTREQUEST = "/newProjectRequestForm";

//#endregion

//#region AD User Url
export const GETUSERDETAILS_URL = "getdetails";
//#endregion

//# Employee Tagging
//export const EMP_SEARCH_URL= "EmployeeTaggingSearch";
// export const CPP_DATA_URL= "EmployeeTaggingSearch/getCPPData";
// export const LOCATION_DATA_URL="EmployeeTaggingSearch/getLoactionData";
export const GETEMPLOYEETAGDETAILSBYUSERID_URL =
  "EmployeeTaggingSearch/getemployeetagdetailsbyuserid";
export const SAVEEMPLOYEETAGDETAILS_URL =
  "EmployeeTaggingSearch/saveemployeetagdetails";
export const UPDATEEMPLOYEETAGDETAILS_URL =
  "EmployeeTaggingSearch/updateemployeetagdetails/";
export const GETEMPLOYEETAGDETAILSBYRITM_URL =
  "EmployeeTaggingSearch/getemployeetagdetailsbyritm";
export const UPDATEEMPLOYEETAGDETAILSBYRITM_URL =
  "EmployeeTaggingSearch/updateoraclesyncstatus";
export const GETBLACKOUTDATES_URL = "EmployeeTaggingSearch/getblackoutdates";
export const GETTaggingHistory_URL =
  "EmployeeTaggingSearch/getemployeetagginghistory";
//#endregion

//# CPP Code Request
export const EMP_SEARCH_URL = "CPPCodeRequest/getemployeesearchdata";
export const CPP_DATA_URL = "CPPCodeRequest/getCPPData";
export const LOCATION_DATA_URL = "CPPCodeRequest/getLoactionData";
export const SAVECPPREQUEST_URL = "CPPCodeRequest/savecpprequest";
export const CPPREQUESTLIST_URL = "CPPCodeRequest/getcpprequestlistbyuserid";
export const DELETECPPREQUEST_URL = "CPPCodeRequest/deletecpprequest";
export const APPROVECPPREQUEST_URL = "CPPCodeRequest/approvecpprequest";
export const DROPDOWNVALUES_URL = "CPPCodeRequest/getdropdowndata";
export const ADMINDROPDOWNVALUES_URL = "CPPCodeRequest/getAdminDropdownData";
export const CONTRACTEDBYCOUNTRY_URL =
  "CPPCodeRequest/getContractedByCountryData";
export const FILTERSEGMENTATTRIBUTES_URL =
  "CPPCodeRequest/getSegmentAttributeData";
export const FILTERTOTALCLIENTSBYMANAGER_URL =
  "CPPCodeRequest/getTotalClientsByManagerData";
export const ValidateClientCode_URL = "CPPCodeRequest/validateclientcode";
export const ValidateParentandUltimateClient_URL =
  "CPPCodeRequest/validateparentandultimateclient";
export const GetParentAndUltimateClient_URL =
  "CPPCodeRequest/getparentandultimateparentdata";
export const ValidateClientName_URL = "CPPCodeRequest/validateclientname";
export const GETDROPDOWNTABLELIST_URL = "CPPCodeRequest/getdropdownlist";
export const GETTIMEZONELIST_URL = "CPPCodeRequest/getTimezoneData";
export const GETCHANNELLIST_URL = "CPPCodeRequest/getChannelData";
export const GETBUSINESSSEGMENTLIST_URL =
  "CPPCodeRequest/getBusinessSegmentsData";

export const MANAGEDROPDOWN_URL = "CPPCodeRequest/managedropdown";
export const LEGALENTITYMAPPINGS_URL = "CPPCodeRequest/GetLegalEntityMappings";
export const REPORTISSUE_URL = "RaiseIncident/raiseincident";
export const SAVECPPCHILDREQUEST_URL = "CPPCodeRequest/saveprogramprojectrequest";
export const PROGRAMPROJECTREQUESTLIST_URL = "CPPCodeRequest/getprogramaprojectdetails";
export const ValidateProgramProject_URL = "CPPCodeRequest/validateprogramproject";
export const EDITPROGRAMPROJECT_URL = "CPPCodeRequest/editprogramproject";
export const APPROVEPROGRAMPROJECTREQUEST_URL = "CPPCodeRequest/approveorrejectprogramproject";
export const GETUSERDETAIL_URL = "CPPCodeRequest/getuserdetails";
export const GETSECURITYGROUPS_URL = "CPPCodeRequest/getsecgroups";
export const SAVEUSERGROUPS_URL = "CPPCodeRequest/saveusergroups";
export const GETPARENTCLIENTSTARTDATE_URL = "CPPCodeRequest/getparentclientstartdate";

//#endregion

//#region CPPO Groups
export const CPPO_EMPTAGGING = "cppo_emptagging";
export const CPPO_EMPAPPROVER = "cppo_empapprover";
export const CPPO_CODECREATION = "cppo_codecreation";
export const CPPO_CODEAPPROVER = "cppo_codeapprover";
export const CPPO_ADMIN = "cppo_admin";
export const CPPO_QA = "cppo-qa";
export const CPPO_DEV = "cppo-devs";
export const GA = "G&A Global - Dynamic";
//#endregion

export const DEFAULT_MAIL = "alex.fagundes@ttecdigital.com";
export const DRP_DEFAULT_NAME = "WFM - N/A";
export const DRP_DEFAULT_CODE = " wfm - n/a";

//timezones
export const TIMEZONES = [
  { name: "Africa/Accra", code: "Africa/Accra" },
  { name: "America/Buenos_Aires", code: "America/Buenos_Aires" },
  { name: "America/Costa_Rica", code: "America/Costa_Rica" },
  { name: "Asia/Kolkata", code: "Asia/Kolkata" },
  { name: "Asia/Manila", code: "Asia/Manila" },
  { name: "Australia/Sydney", code: "Australia/Sydney" },
  { name: "Brazil/East", code: "Brazil/East" },
  { name: "Brazil/West", code: "Brazil/West" },
  { name: "Canada/Atlantic", code: "Canada/Atlantic" },
  { name: "Canada/Central", code: "Canada/Central" },
  { name: "Canada/Eastern", code: "Canada/Eastern" },
  { name: "Canada/Mountain", code: "Canada/Mountain" },
  { name: "Canada/Pacific", code: "Canada/Pacific" },
  { name: "Europe/Amsterdam", code: "Europe/Amsterdam" },
  { name: "Europe/Berlin", code: "Europe/Berlin" },
  { name: "Europe/Brussels", code: "Europe/Brussels" },
  { name: "Europe/Copenhagen", code: "Europe/Copenhagen" },
  { name: "Europe/Dublin", code: "Europe/Dublin" },
  { name: "Europe/London", code: "Europe/London" },
  { name: "Europe/Madrid", code: "Europe/Madrid" },
  { name: "Europe/Paris", code: "Europe/Paris" },
  { name: "Europe/Rome", code: "Europe/Rome" },
  { name: "Europe/Stockholm", code: "Europe/Stockholm" },
  { name: "Europe/Zurich", code: "Europe/Zurich" },
  { name: "GMT", code: "GMT" },
  { name: "Hongkong", code: "Hongkong" },
  { name: "Mexico/General", code: "Mexico/General" },
  { name: "Pacific/Auckland", code: "Pacific/Auckland" },
  { name: "US/Arizona", code: "US/Arizona" },
  { name: "US/Central", code: "US/Central" },
  { name: "US/Eastern", code: "US/Eastern" },
  { name: "US/Hawaii", code: "US/Hawaii" },
  { name: "US/Mountain", code: "US/Mountain" },
  { name: "US/Pacific", code: "US/Pacific" },
];

//export const ALLOWEDSECURITYGROUP="CPPO_Allowed_Group";
//export const APP_BASE_URL =  process.env.REACT_APP_API_URI as string;

// # Build references
// export const BUILD_ID =  process.env.REACT_APP_BUILD_ID as string;
// export const BUILD_NUMBER =  process.env.REACT_APP_BUILD_NUMBER as string;

// # define the API remote and settings
//export const BASE_URL =  process.env.REACT_APP_API_URI as string;
// export const API_APIM_SUBSCRIPTION_KEY = process.env
//   .REACT_APP_API_APIM_SUBSCRIPTION_KEY as string;

// # ASKNow
//export const ASKNOW_BASE_URL =  process.env.REACT_APP_ASKNOW_API_URI as string;

/**
 * Omit the addition of custom headers (i.e. Ocp-Apim-Subscription-Key and x-correlation-id)
 * on requests that match partially by path. Its a list as we might need to add more
 * in future.
 */
export const OmitCustomHeadersPaths = ["appversion"];
